import * as Sentry from '@sentry/react';
import { configureStore } from '@reduxjs/toolkit';
import { crashReporter, logger } from 'Douleutaras/redux/middleware';

import reducer from './reducers';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

export const initializeStore = initialState => {
  return configureStore({
    reducer,
    preloadedState: initialState,
    devTools: process.env.NODE_ENV !== 'production',
    enhancers: [ sentryReduxEnhancer ],
    middleware: getDefaultMiddleware => getDefaultMiddleware({
      serializableCheck: false
    })
      .concat([
        logger
        // after this function handler, the middleware chain will end.
        // So if you need to add more middlewares, you should place it above.
        // crashReporter
      ])
  });
};

// On the client, hydrate from the state the SSR server serialised into the page.
// On the server this global is never set, so we fall back to a blank slate.
const preloadedState = typeof window !== 'undefined'
  ? (window as Window & { _PRELOADED_STATE?: object })._PRELOADED_STATE
  : undefined;

export const store = initializeStore(preloadedState ?? { auth: { user: {} } });
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
